// extracted by mini-css-extract-plugin
export default {"alert":"ResultZone_alert__Yk+Ig","resultZoneContainer":"ResultZone_resultZoneContainer__XtI6W"};